import { EventMetricsKeys } from '../types';

// TODO: refactor all the current UI ones to here
export default [
  // This metric usage has been removed from the codebase. The volume of it
  // tells us how many times the user attempted to view the capability tooltip
  // on the entity link with ellipsis. Check the data on Socrates from period
  // 2024-02-19 to 2024-03-01
  // https://data-portal.internal.atlassian.com/analytics/registry/61287
  {
    key: EventMetricsKeys.EntityLinkViewedCapabilityTooltip,
    data: {
      actionSubject: 'tooltip',
      action: 'viewed',
      actionSubjectId: 'capabilityTruncated',
      source: 'entityLink',
    },
  },

  // https://data-portal.internal.atlassian.com/analytics/registry/61193
  {
    key: EventMetricsKeys.DashboardFilterBarToggledBreach,
    data: {
      actionSubject: 'filterBar',
      action: 'toggled',
      actionSubjectId: 'breach',
      source: 'dashboard',
    },
  },
  // https://data-portal.internal.atlassian.com/analytics/registry/61190
  {
    key: EventMetricsKeys.DashboardFilterBarToggledQualityIssue,
    data: {
      actionSubject: 'filterBar',
      action: 'toggled',
      actionSubjectId: 'qualityIssue',
      source: 'dashboard',
    },
  },
  // https://data-portal.internal.atlassian.com/analytics/registry/61194
  {
    key: EventMetricsKeys.DashboardFilterBarToggledDraft,
    data: {
      actionSubject: 'filterBar',
      action: 'toggled',
      actionSubjectId: 'draft',
      source: 'dashboard',
    },
  },
  // https://data-portal.internal.atlassian.com/analytics/registry/69733
  {
    key: EventMetricsKeys.CreateClickedCopyExperienceKeyButton,
    data: {
      actionSubject: 'button',
      action: 'clicked',
      actionSubjectId: 'copyExperienceKey',
      source: 'create',
    },
  },
];
